import type { MouseEventHandler } from 'react';
import type { ButtonProps } from '../Button/Button';

import { useCallback } from 'react';
import { Link } from 'react-router';
import { twMerge } from 'tailwind-merge';

import Button from '../Button/Button';

const colorClasses = {
  blue: 'focus:text-white active:text-white',
  blueBordered:
    'focus:text-blue focus:hover:text-white active:text-blue active:hover:text-white',
};

export interface LinkButtonProps extends Omit<
  ButtonProps<typeof Link>,
  'as' | 'to' | 'type'
> {
  /**
   * Link to navigate on click
   */
  link?: string;
  /**
   * On click callback
   */
  onClick?: () => void;
}

const LinkButton = ({
  link = '',
  children,
  onClick,
  disabled = false,
  additionalClasses,
  buttonColor = 'blue',
  ...props
}: LinkButtonProps) => {
  const onClickCallback = useCallback<MouseEventHandler<HTMLAnchorElement>>(
    (e) => {
      e.stopPropagation();

      if (disabled) {
        e.preventDefault();
        return;
      }
      onClick?.();
    },
    [disabled, onClick],
  );

  return (
    <Button
      as={Link}
      to={link}
      onClick={onClickCallback}
      disabled={disabled}
      additionalClasses={twMerge(
        'focus:no-underline dark:text-slate-200 active:no-underline w-fit',
        buttonColor in colorClasses
          ? colorClasses[buttonColor as keyof typeof colorClasses]
          : 'focus:text-slate-900 active:text-slate-900',
        buttonColor === 'borderless' ? '' : 'hover:no-underline',
        additionalClasses,
      )}
      buttonColor={buttonColor}
      {...props}
      type={undefined}
    >
      {children}
    </Button>
  );
};

export default LinkButton;
